module.exports = __webpack_public_path__ + "static/img/220717teryMessenger002_img.9ef85da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/220717teryMessenger002_img.png
// module id = 5CDD
// module chunks = 1